import { StaticBaseDao } from '@/dao';
import { CopyStartTimesRequest, PostResponse, StartingNumberSetFlagRequest, StartingNumberSetHistoryRequest } from '@/objects/generated';

export class StartingNumberDao extends StaticBaseDao {
    public static async CopyStartTimesToContestants(eventID: number, request: CopyStartTimesRequest): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `StartingNumber/CopyStartTimesToContestants` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            request,
        );
    }
    public static async CopyStartTimesFromContestant(eventID: number, request: CopyStartTimesRequest): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `StartingNumber/CopyStartTimesFromContestant` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            request,
        );
    }
    public static async SetFlagsToContestants(eventID: number, request: StartingNumberSetFlagRequest): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `StartingNumber/SetFlagsToContestants` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            request,
        );
    }
    public static async UpdateBibsFromHistory(eventID: number, request: StartingNumberSetHistoryRequest): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `StartingNumber/UpdateBibsFromHistory` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            request,
        );
    }
}
